'use client';

import { Box, Container, useTheme } from '@mui/material';

import { SingleReview } from '@/components/Reviews/ReviewComponent';
import { Review } from '@/types';

export function SingleReviewFullWidth({ review }: { review: Review }) {
  const theme = useTheme();
  return (
    <Container maxWidth="sm" sx={{ mt: 17, position: 'relative' }}>
      {/* @ts-expect-error ts version not recognizing classNames prop ? */}
      <Box classNames="embla__slide embla__class-names is-snapped is-in-view">
        <SingleReview
          classNames="embla__slide__number"
          key={review.documentId}
          review={review}
          sx={{
            flexDirection: 'column',
            padding: {
              xs: '8rem 2rem 2rem 2rem',
              md: '8rem 5.875rem 4rem 6rem',
            },
            backgroundImage: theme.palette.gradients.reviewCard,
          }}
        />
      </Box>
    </Container>
  );
}
